<div class="wrapper">
  <div class="title"> Order afbeeldingen</div>
  <div class="upload-zone">
    <ng-container *ngIf="!safeImageUrl">
      <div class="empty-state" (click)="takePhoto()">
        <ion-icon class="export" src="../../../../../../assets/icon/export.svg"></ion-icon>
        <div class="upload-text">Klik hier om een afbeelding toe te voegen</div>
      </div>
    </ng-container>
    <ng-container *ngIf="safeImageUrl">
      <img [src]="safeImageUrl">
      <div (click)="clearImage($event)" class="trash">
        <ion-icon src="../../../../../../assets/icon/trash.svg"></ion-icon>
      </div>
    </ng-container>
  </div>
  <div class="action-buttons">
    <ion-button [disabled]="!blob" (click)="uploadPhoto()" class="save">Opslaan</ion-button>
  </div>
</div>